import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import { EVENT_NAME } from './constants';
import { Tracker } from '../Tracker';

var EVENT_LABEL_NAMES = {
  myBets: 'My Bets',
  accountHistory: 'My Transactions',
  withdraw: 'Withdraw',
  withdrawAccountVerification: 'Withdraw',
  reversalWithdraw: 'Reverse Withdrawal',
  myRewards: 'Promotions',
  myAccount: 'Account Preferences',
  depositLimit: 'Deposit Limit',
  deposit: 'Deposit',
  gamblingControls: 'Gambling Controls',
  saferGambling: 'Safer Gambling',
  pokerBalanceTransfer: 'Poker Balance Transfer',
  profitAndLoss: 'Profit And Loss Summary',
  '/TransactionsHistory/History': 'My Transactions'
};

export var NavigationMenuTracker = function (_Tracker) {
  _inherits(NavigationMenuTracker, _Tracker);

  function NavigationMenuTracker() {
    _classCallCheck(this, NavigationMenuTracker);

    return _possibleConstructorReturn(this, (NavigationMenuTracker.__proto__ || _Object$getPrototypeOf(NavigationMenuTracker)).apply(this, arguments));
  }

  _createClass(NavigationMenuTracker, [{
    key: 'menuItemClicked',
    value: function menuItemClicked(id) {
      this.publishPartialEvent(EVENT_NAME, {
        ElementType: 'Spitfire',
        EventLabel: EVENT_LABEL_NAMES[id] || id
      });
    }
  }]);

  return NavigationMenuTracker;
}(Tracker);